


























































































import Vue from "vue";
import store from "@/store/index";
import statusCodes from "@/config/status-codes";

export default Vue.extend({
  name: "English",

  data() {
    return {
      task: {
        taskNumber: 0
      },
      tasksAmount: 0,
      finished: false,
      tick: null as any,
      isDangerRemaining: false,
      selectedAnswer: 1,
      score: 0,
      answerLoading: false
    };
  },

  computed: {
    remaining(): number {
      this.isDangerRemaining = this.$store.state.english.remainingTime < 5;
      return this.$store.state.english.remainingTime;
    },
    deadline(): boolean {
      return this.$store.state.english.remainingTime == 0;
    },
    english(): any {
      return this.$store.state.english;
    }
  },

  watch: {
    async remaining() {
      if (this.deadline) {
        clearInterval(this.tick);
        await this.$store.dispatch("english/finish");
        this.finished = true;
      }
    }
  },

  async beforeRouteEnter(to, from, next) {
    try {
      Vue.set(store.state.english, "loading", true);
      await store.dispatch("english/getQuestion");
      await store.dispatch("english/getRemainingTime");
      Vue.set(store.state.english, "loading", false);
      next();
    } catch (e) {
      Vue.set(store.state.english, "loading", false);

      if (e.code === statusCodes.NOT_ACTIVE_EXAM
        || e.code === statusCodes.NOT_ACTIVE_SESSION
        || e.code === statusCodes.CONCURRENT_EXAM) {
        next("/");
      } else {
        Vue.set(store.state.general, "exception", true);
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.tick);
    Vue.set(this.$store.state.general.examsList.english, "finished", this.finished);
    Vue.set(this.$store.state.general.examsList.english, "started", !this.finished);
    next();
  },

  mounted() {
    this.task = this.english.task;
    this.tasksAmount = this.english.tasksAmount;
    this.selectedAnswer = 1;
    this.tick = setInterval(() => {
      this.$store.dispatch("english/getRemainingTime");
    }, 60000);
  },

  methods: {
    async getQuestion() {
      try {
        await this.$store.dispatch("english/getQuestion");
        this.task = this.english.task;
        this.tasksAmount = this.english.tasksAmount;
        this.selectedAnswer = 1;
      } catch (e) {
        Vue.set(this.$store.state.general, "exception", true);
      }
    },

    async saveAnswer() {
      this.answerLoading = true;

      try {
        await this.$store.dispatch("english/saveAnswer", {
          taskNumber: this.task.taskNumber,
          answer: this.selectedAnswer
        });

        this.finished = this.english.finished;
        this.score = this.english.score;

        if (!this.finished) {
          await this.getQuestion();
        }
      } catch (e) {
        Vue.set(this.$store.state.general, "exception", true);
      }

      this.answerLoading = false;
    },

    exit() {
      this.$router.push({name: "home"});
    }
  }
});
